import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { useNavigationItems } from '@hooks';

import { FooterContainer } from './styles';
import { ConstLink } from '../const-link';

interface IFooterProps extends React.HTMLAttributes<HTMLDivElement> {}

const Footer = ({ className, ...rest }: IFooterProps) => {
  const navigation = useNavigationItems('footer');

  return (
    <FooterContainer className={['footer', className].join(' ')} {...rest}>
      <div className="footer__row">
        <StaticImage
          className="footer__logo"
          src="../../images/al-logo-better-days.png"
          alt="Accident Legal™ - Better days ahead"
        />
        <div className="footer__misc">
          <div className="footer__links">
            {navigation.map(({ href, innerText }) => {
              return (
                <Link className="footer__link" to={href} key={innerText}>
                  {innerText}
                </Link>
              );
            })}
          </div>
          <p className="footer__legal">
            Accident Legal is an expert compensation law firm. We offer you our
            no win-no fee guarantee and free initial consultation. You can read
            our Privacy Policy by following{' '}
            <ConstLink to="/privacy-policy">this link</ConstLink>, and our
            Website Terms of Use by following{' '}
            <ConstLink to="/website-terms-of-use">this link</ConstLink>. Icons
            made by Vectors-Market, Eleonor Wang, Freepik, Roundicons, Pixel
            Perfect, Icon Pond, Flat Icons and Icon Monk. &copy;
            {new Date().getFullYear()} Accident Legal.
          </p>
        </div>
      </div>
    </FooterContainer>
  );
};

export { Footer };
